import { render } from "./SkillsMatrices.vue?vue&type=template&id=b7824b48&ts=true"
import script from "./SkillsMatrices.vue?vue&type=script&lang=ts"
export * from "./SkillsMatrices.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__